const cards = [
  {
    title: '动作大片',
    desc: '火爆刺激的动作电影合集，肾上腺素飙升的视觉盛宴',
    icon: 'ri-knife-blood-line',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20style%20scene%20with%20explosive%20energy%2C%20dynamic%20composition%20with%20warm%20orange%20and%20crimson%20tones%2C%20abstract%20motion%20blur%20effect%2C%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20bold%20cinematic%20atmosphere&width=600&height=400&seq=card-action-movie&orientation=landscape',
  },
  {
    title: '喜剧电影',
    desc: '轻松欢乐的喜剧电影分类，承包你一整天的好心情',
    icon: 'ri-emotion-laugh-line',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20movie%20poster%20style%20scene%20with%20playful%20colors%20in%20warm%20yellow%20and%20coral%20tones%2C%20lighthearted%20composition%2C%20soft%20bokeh%20background%2C%20cinematic%20photography%20style%2C%20joyful%20and%20vibrant%20atmosphere&width=600&height=400&seq=card-comedy-movie&orientation=landscape',
  },
  {
    title: '科幻巨制',
    desc: '震撼视觉的科幻大片，带你探索未知的宇宙与未来世界',
    icon: 'ri-rocket-line',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20style%20scene%20with%20cosmic%20elements%20and%20nebulae%2C%20deep%20space%20background%2C%20warm%20bronze%20and%20deep%20crimson%20accents%2C%20cinematic%20lighting%2C%20epic%20atmosphere%2C%20artistic%20composition&width=600&height=400&seq=card-scifi-movie&orientation=landscape',
  },
  {
    title: '爱情文艺',
    desc: '温暖治愈的爱情与文艺片，细腻情感触动你的内心深处',
    icon: 'ri-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20style%20scene%20with%20soft%20warm%20lighting%2C%20gentle%20rose%20and%20peach%20toned%20composition%2C%20dreamy%20bokeh%20effect%2C%20cinematic%20photography%2C%20intimate%20and%20tender%20atmosphere%2C%20elegant%20aesthetic&width=600&height=400&seq=card-romance-movie&orientation=landscape',
  },
  {
    title: '恐怖惊悚',
    desc: '悬疑恐怖电影精选，紧张刺激让你体验心跳加速的快感',
    icon: 'ri-ghost-line',
    image: 'https://readdy.ai/api/search-image?query=Atmospheric%20horror%20movie%20poster%20style%20scene%20with%20dark%20shadows%20and%20dramatic%20chiaroscuro%20lighting%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20mysterious%20composition%2C%20cinematic%20tension%2C%20gothic%20atmosphere&width=600&height=400&seq=card-horror-movie&orientation=landscape',
  },
  {
    title: '动画精选',
    desc: '高分动画电影合集，适合全家一起观看的精彩动画作品',
    icon: 'ri-palette-line',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20animation%20movie%20poster%20style%20scene%20with%20colorful%20playful%20composition%2C%20warm%20amber%20and%20golden%20tones%2C%20artistic%20illustration%20feel%2C%20whimsical%20atmosphere%2C%20cinematic%20quality%2C%20joyful%20and%20imaginative&width=600&height=400&seq=card-animation-movie&orientation=landscape',
  },
  {
    title: '纪录纪实',
    desc: '高分纪录片精选，真实故事带你领略世界的不同面貌与深度',
    icon: 'ri-camera-lens-line',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20poster%20style%20scene%20with%20natural%20earthy%20tones%2C%20warm%20sepia%20and%20amber%20hues%2C%20authentic%20composition%2C%20cinematic%20photography%20style%2C%20contemplative%20atmosphere%2C%20elegant%20minimalist%20aesthetic&width=600&height=400&seq=card-docu-movie&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            电影分类浏览
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按类型快速找到你想看的电影，涵盖院线热门与经典佳作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cards.slice(0, 4).map((card, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-40">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 backdrop-blur-sm">
                    <i className={`${card.icon} text-white text-sm`}></i>
                  </div>
                  <h3 className="text-white font-semibold text-sm font-heading">{card.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-5">
          {cards.slice(4).map((card, i) => (
            <div
              key={i + 4}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-36">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 backdrop-blur-sm">
                    <i className={`${card.icon} text-white text-sm`}></i>
                  </div>
                  <h3 className="text-white font-semibold text-sm font-heading">{card.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}